require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-mattersburg-neudoerfl.json") })
        }
      }, "path---betreuungseinrichtungen-mattersburg-neudoerfl");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-mattersburg-neudoerfl!./.cache/json/betreuungseinrichtungen-mattersburg-neudoerfl.json
// module id = 933
// module chunks = 231608221292675